import { setFlashRedirectToCurrentLocation } from "@impero-com/common/utils/flash";
import { RETRY_COUNT } from "@impero-com/common/utils/query_client";
import { useSuspenseQuery } from "@tanstack/react-query";

import { getLoginSsoBehavior } from "api/generated/authentication/authentication";

import { WebRoute } from "../../routes";
import { HARDCODED_BACKEND_PATHS } from "../hardcodedBackendPaths";

/**
 * Check SSO behavior and redirect if needed.
 */
export function useSsoRedirect() {
    const searchParams = new URLSearchParams(window.location.search);
    const noRedirect = searchParams.has("noRedirect");

    const { data } = useSuspenseQuery({
        queryKey: ["login-sso-behavior", noRedirect],
        queryFn: () => (!noRedirect ? getLoginSsoBehavior() : null),
        select: (response) => response?.data,
        staleTime: Infinity,
        retry: RETRY_COUNT,
    });

    const immediateRedirect =
        data?.type === "enabled" && data.immediate_redirect;
    const shouldRedirect = immediateRedirect && !noRedirect;

    if (shouldRedirect) {
        // Automatic SSO runs before the anonymous router can save the return URL.
        if (window.location.pathname === WebRoute.OAUTH_AUTHORIZE) {
            setFlashRedirectToCurrentLocation();
        }
        redirectToSso();
    }
}

// This function redirects to SSO and ensures that the suspense boundary remains
// We should migrate to `use` instead after upgrading to React 19
function redirectToSso() {
    window.location.href = HARDCODED_BACKEND_PATHS.SSO;
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw new Promise(() => {});
}
